import { hasValue } from "../../../../utils";

export const hydrateNe1Form = (customerData) => {
  const settings = customerData?.settings || {};

  return {
    poa: settings.poaWithinHrs ?? "",
    poaType: settings.poaType || "hours",
    reEval: hasValue(settings.reEvalWithinHrs) ? settings.reEvalWithinHrs : 168,
    woundAssessmentScore: settings.woundAssessmentScore === "push" ? "push" : "bwat",
    riskAssessmentScale: settings.riskAssessmentScale === "braden" ? "braden" : "norton",
    aiTissueType: settings.aiTissueType === 1 ? 1 : 0,
    aihistorycause: settings.historyCause === 1 ? 1 : 0,
    copyDataFromPreviousAssessment: settings.copyDataFromPreviousAssessment === 1 ? 1 : 0,
    signWithOutMinimumDataset: settings.signWithOutMinimumDataset === 1 ? 1 : 0,
    characteristics: settings.signCriteria?.characteristics ?? [],
    measurements: settings.signCriteria?.measurements ?? [],
    treatment: settings.signCriteria?.treatment ?? [],
    unableToAssessWound: settings.unableToAssessWound === 1 ? 1 : 0,
    patientRefusalReasons: settings.patientRefusalReasons ?? [],
    measureType: settings.measureType === "longestlength" ? "longestlength" : "headtotoe",
    woundEdgeAutoTracing: settings.woundEdgeAutoTracing === 1 ? 1 : 0,
    isAIWoundCapture: settings.isAIWoundCapture === 1 ? 1 : 0,
    skipPhoto: settings.skipPhoto === 1 ? 1 : 0,
    combinedMultiSegmentIntoOne: settings.combinedMultiSegmentIntoOne === 1 ? 1 : 0,
    displayBinaryImage: settings.displayBinaryImage === 1 ? 1 : 0,
    hasSecondoryPhotos: settings.hasSecondoryPhotos === 1 ? 1 : 0,
    isConsolidatedPdfEnable: settings.isConsolidatedPdfEnable === 1 ? 1 : 0,
    pdfWoundImageType: settings.pdfWoundImageType ?? "measuredimage",
    profileWoundImageType: settings.profileWoundImageType ?? "rawimage",
    measurementWoundImageType: settings.measurementWoundImageType ?? "measuredimage",
  };
};

export const buildNe1Payload = ({ form, customerData, ne1State, popupSave }) => {
  const settings = customerData?.settings || {};

  return {
    ...customerData,
    settings: {
      companyLogo: settings.companyLogo,
      customerStatus: settings.customerStatus,
      domain: settings.domain,
      sessionTimeout: settings.sessionTimeout,
      sessionTimeoutType: settings.sessionTimeoutType,
      pdfAutoGen: settings.pdfAutoGen,
      ne1Wms: ne1State === 1 ? 1 : 0,
      poaWithinHrs: form.poa,
      poaType: form.poaType,
      reEvalWithinHrs: form.reEval,
      woundEdgeAutoTracing: form.woundEdgeAutoTracing,
      measureType: form.measureType,
      riskAssessmentScale: form.riskAssessmentScale,
      woundAssessmentScore: form.woundAssessmentScore,
      aiTissueType: form.aiTissueType,
      historyCause: form.aihistorycause,
      soldToShipToForZ002: popupSave === true ? 1 : 0,
      copyDataFromPreviousAssessment: form.copyDataFromPreviousAssessment,
      signWithOutMinimumDataset: form.signWithOutMinimumDataset,
      signCriteria: {
        characteristics: form.characteristics ?? [],
        measurements: form.measurements ?? [],
        treatment: form.treatment ?? [],
      },
      unableToAssessWound: form.unableToAssessWound,
      skipPhoto: form.skipPhoto,
      isConsolidatedPdfEnable: form.isConsolidatedPdfEnable,
      combinedMultiSegmentIntoOne: form.combinedMultiSegmentIntoOne,
      displayBinaryImage: form.displayBinaryImage,
      pdfWoundImageType: form.pdfWoundImageType,
      profileWoundImageType: form.profileWoundImageType,
      measurementWoundImageType: form.measurementWoundImageType,
      hasSecondoryPhotos: form.hasSecondoryPhotos,
      isAIWoundCapture: form.isAIWoundCapture,
      patientRefusalReasons: form.patientRefusalReasons ?? [],
    },
  };
};
